import { useField } from 'formik'
import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'
import { useBrandVisualKit } from 'hooks/queries/workspaces/useBrandVisualKit'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const useFormBrandVisualKit = () => {
  const [{ value: brand_visual_kit_id }, ,] = useField('brand_visual_kit_id')
  const [{ value: brandKitId }, ,] = useField('brand_kit_id')
  const brandKitsEnabled = useFlipperFlag('brand_kits')
  const brandKit = useBrandKit(brandKitId, { enabled: brandKitsEnabled && Boolean(brandKitId) }).data?.brand_kit
  const brandVisualKit = useBrandVisualKit(
    { id: brand_visual_kit_id },
    {
      enabled: !brandKitsEnabled && Boolean(brand_visual_kit_id),
    },
  ).data?.brand_visual_kit

  return brandKit?.brand_visual_kit || brandVisualKit
}
